<template>
	<side-window class="tracking-history" title="Historik" @pop="$emit('pop')" @close="$emit('close')">
		<div class="vehicle-item">
			<div class="label">{{ label }}</div>
		</div>
		<date-picker-view @change="update" class="date-picker" :style="{
			width: '100%'
		}" />
		<div class="history">
			<div v-for="(event, idx) in history" :key="idx">
				<div class="grid">
					<div>{{ event.type }}</div>
					<div style="text-align: right;">{{ event.created | timestamp }}</div>
				</div>
				<div v-if="event.name" class="middle">{{ event.name }}</div>
			</div>
		</div>
	</side-window>
</template>

<script>

	//import Edit from '../../components/Edit'
	//import FormLine from '../../components/FormLine'
	//import FormGrid from '../../components/FormGrid'
	//import Button from '../../components/Button'
	//import Select from '../../components/Select'
	//import Switch from '../../components/Switch'
	//import ProfilePhoto from '../../components/ProfilePhoto'
	//import Tabs from '../../components/Tabs'
	//import Memo from '../../components/Memo'
	//import Entity from '../../components/Entity'

	export default {
		data: function () {
			return {
				vehicles: [],
				history: [],
				date: null
			};
		},
		props: {
			id: Number,
			label: String,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			vehicleSelect(id, label) {
				
			},
			update(date) {
				
				this.date = date;

				var win = this;

				this.axios
					.get('/employees/' + this.id + '/history/' + date + '/')
					.then(function (r) {
						win.history = r.data;

						
					});
			},
			print() {
				
				window.open('/api/v1/geofence.php?&date=' + this.date);
			},
			printThis() {
				
				window.open('/api/v1/geofence.php?&date=' + this.date + '&id=' + this.id);
			}
		},
		mounted: function() {
			
			

			var win = this;

			//this.update(this.date);
		}
	}
</script>

<style lang="scss">
	.vehicle-item {
		padding: 20px 20px 20px 20px;
		border-bottom: 1px solid #333;
		cursor: pointer;
	}

	.date-picker {
		border-bottom: 1px solid #333;
	}

	.history {
		
	}

	.history > div {
		padding: 20px;
		border-bottom: 1px solid #333;
		overflow: hidden;
	}

	.history > div > div.grid {
		display: grid;
		grid-template-columns: 1fr 2fr;
	}

	.history > div > div.middle {
		padding: 10px 0 0 0;
		font-size: 12px;
		overflow: hidden;
	}



	.history > div > div.bottom > div {
		text-align: center;
		overflow: hidden;
	}

	.history > div > div.middle > a {
		color: #f7223f;
	}

	.history > div > div.bottom > div > span {
		display: block;
		text-align: center;
		font-size: 12px;
		color: #ccc;
		padding-bottom: 10px;
	}
</style>
